/**
 * Os planos na tela com o que um admin editou (docs/spec/planos.md, "Editar os planos"): o nome na
 * língua escolhida e a grade que vale. Antes de o catálogo chegar do servidor, valem os do código.
 */
import { useLanguage, useT } from '../i18n/index.js';
import { PLANS, gridOf, isPlanId, type PlanGrid } from '../shared.js';
import { useApp } from '../store.js';
import { planName } from './planModel.js';

/** O nome de cada plano, com o nome editado da língua da tela. */
export function usePlanName(): (planId: string) => string {
  const t = useT();
  const language = useLanguage((s) => s.language);
  const catalog = useApp((s) => s.planCatalog);
  return (planId) => planName(t, planId, catalog && isPlanId(planId) ? catalog[planId].names : null, language);
}

/** A grade que vale: a do catálogo do servidor, ou a do código enquanto ele não chega. */
export function usePlanGrid(): PlanGrid {
  const catalog = useApp((s) => s.planCatalog);
  return catalog ? gridOf(catalog) : PLANS;
}
